{
  "abi": [
    {
      "type": "constructor",
      "inputs": [],
      "stateMutability": "nonpayable"
    },
    {
      "type": "function",
      "name": "TIMELOCK_DURATION",
      "inputs": [],
      "outputs": [
        {
          "name": "",
          "type": "uint256",
          "internalType": "uint256"
        }
      ],
      "stateMutability": "view"
    },
    {
      "type": "function",
      "name": "algorithms",
      "inputs": [
        {
          "name": "",
          "type": "uint8",
          "internalType": "uint8"
        }
      ],
      "outputs": [
        {
          "name": "",
          "type": "address",
          "internalType": "address"
        }
      ],
      "stateMutability": "view"
    },
    {
      "type": "function",
      "name": "cancelProposal",
      "inputs": [
        {
          "name": "algId",
          "type": "uint8",
          "internalType": "uint8"
        }
      ],
      "outputs": [],
      "stateMutability": "nonpayable"
    },
    {
      "type": "function",
      "name": "executeProposal",
      "inputs": [
        {
          "name": "algId",
          "type": "uint8",
          "internalType": "uint8"
        }
      ],
      "outputs": [],
      "stateMutability": "nonpayable"
    },
    {
      "type": "function",
      "name": "finalizeSetup",
      "inputs": [],
      "outputs": [],
      "stateMutability": "nonpayable"
    },
    {
      "type": "function",
      "name": "getAlgorithm",
      "inputs": [
        {
          "name": "algId",
          "type": "uint8",
          "internalType": "uint8"
        }
      ],
      "outputs": [
        {
          "name": "",
          "type": "address",
          "internalType": "address"
        }
      ],
      "stateMutability": "view"
    },
    {
      "type": "function",
      "name": "owner",
      "inputs": [],
      "outputs": [
        {
          "name": "",
          "type": "address",
          "internalType": "address"
        }
      ],
      "stateMutability": "view"
    },
    {
      "type": "function",
      "name": "proposals",
      "inputs": [
        {
          "name": "",
          "type": "uint8",
          "internalType": "uint8"
        }
      ],
      "outputs": [
        {
          "name": "algorithm",
          "type": "address",
          "internalType": "address"
        },
        {
          "name": "proposedAt",
          "type": "uint256",
          "internalType": "uint256"
        }
      ],
      "stateMutability": "view"
    },
    {
      "type": "function",
      "name": "proposeAlgorithm",
      "inputs": [
        {
          "name": "algId",
          "type": "uint8",
          "internalType": "uint8"
        },
        {
          "name": "algorithm",
          "type": "address",
          "internalType": "address"
        }
      ],
      "outputs": [],
      "stateMutability": "nonpayable"
    },
    {
      "type": "function",
      "name": "registerAlgorithm",
      "inputs": [
        {
          "name": "algId",
          "type": "uint8",
          "internalType": "uint8"
        },
        {
          "name": "algorithm",
          "type": "address",
          "internalType": "address"
        }
      ],
      "outputs": [],
      "stateMutability": "nonpayable"
    },
    {
      "type": "function",
      "name": "setupComplete",
      "inputs": [],
      "outputs": [
        {
          "name": "",
          "type": "bool",
          "internalType": "bool"
        }
      ],
      "stateMutability": "view"
    },
    {
      "type": "function",
      "name": "transferOwnership",
      "inputs": [
        {
          "name": "newOwner",
          "type": "address",
          "internalType": "address"
        }
      ],
      "outputs": [],
      "stateMutability": "nonpayable"
    },
    {
      "type": "function",
      "name": "validateSignature",
      "inputs": [
        {
          "name": "hash",
          "type": "bytes32",
          "internalType": "bytes32"
        },
        {
          "name": "signature",
          "type": "bytes",
          "internalType": "bytes"
        }
      ],
      "outputs": [
        {
          "name": "validationData",
          "type": "uint256",
          "internalType": "uint256"
        }
      ],
      "stateMutability": "view"
    },
    {
      "type": "event",
      "name": "AlgorithmProposed",
      "inputs": [
        {
          "name": "algId",
          "type": "uint8",
          "indexed": true,
          "internalType": "uint8"
        },
        {
          "name": "algorithm",
          "type": "address",
          "indexed": true,
          "internalType": "address"
        },
        {
          "name": "executeAfter",
          "type": "uint256",
          "indexed": false,
          "internalType": "uint256"
        }
      ],
      "anonymous": false
    },
    {
      "type": "event",
      "name": "AlgorithmRegistered",
      "inputs": [
        {
          "name": "algId",
          "type": "uint8",
          "indexed": true,
          "internalType": "uint8"
        },
        {
          "name": "algorithm",
          "type": "address",
          "indexed": true,
          "internalType": "address"
        }
      ],
      "anonymous": false
    },
    {
      "type": "event",
      "name": "OwnershipTransferred",
      "inputs": [
        {
          "name": "previousOwner",
          "type": "address",
          "indexed": true,
          "internalType": "address"
        },
        {
          "name": "newOwner",
          "type": "address",
          "indexed": true,
          "internalType": "address"
        }
      ],
      "anonymous": false
    },
    {
      "type": "event",
      "name": "ProposalCancelled",
      "inputs": [
        {
          "name": "algId",
          "type": "uint8",
          "indexed": true,
          "internalType": "uint8"
        }
      ],
      "anonymous": false
    },
    {
      "type": "event",
      "name": "SetupFinalized",
      "inputs": [],
      "anonymous": false
    },
    {
      "type": "error",
      "name": "AlgorithmAlreadyRegistered",
      "inputs": []
    },
    {
      "type": "error",
      "name": "AlgorithmNotRegistered",
      "inputs": []
    },
    {
      "type": "error",
      "name": "EmptySignature",
      "inputs": []
    },
    {
      "type": "error",
      "name": "InvalidAlgorithmAddress",
      "inputs": []
    },
    {
      "type": "error",
      "name": "NoActiveProposal",
      "inputs": []
    },
    {
      "type": "error",
      "name": "OnlyOwner",
      "inputs": []
    },
    {
      "type": "error",
      "name": "ProposalAlreadyPending",
      "inputs": []
    },
    {
      "type": "error",
      "name": "SetupAlreadyClosed",
      "inputs": []
    },
    {
      "type": "error",
      "name": "TimelockNotExpired",
      "inputs": [
        {
          "name": "remaining",
          "type": "uint256",
          "internalType": "uint256"
        }
      ]
    }
  ]
}
